import React from 'react';
import { IContent } from '../../../types';
import { ProductPushItem } from '../../../types/content';
import { withContent } from '../../../hoc/withContext';
import './TriplePushBlock.scss';

import Title from '../../Elements/Title/TitleElement';
import ProductPushElement from '../../Elements/ProductPush/ProductPushElement';

interface ITriplePushProps {
  context?: IContent;
  type?: string;
}

const TriplePush = ({ context, type }: ITriplePushProps) => {
  // @ts-ignore
  const triple_push = type && context[`triple_push_${type}`]
    // @ts-ignore
    ? context[`triple_push_${type}`]
    : context.triple_push
      ? context.triple_push
      : null;

  if (!triple_push) {
    return null;
  }

  const { is_active, items, title } = triple_push;
  const itemsList = items.map((item: ProductPushItem, index: number) => {
    return (
      <ProductPushElement
        key={index}
        index={index}
        info={item}
      />
    )
  });

  return is_active && (
    <div className="block-triple_push">
      {title && (
        <Title>{title}</Title>
      )}
      <div className="items">
        {itemsList}
      </div>
    </div>
  );
};

export default withContent(TriplePush);
